module.exports = __webpack_public_path__ + "static/media/PM145.ca3b2810.png";